module.exports = __webpack_public_path__ + "static/media/dtan@2x.27b0e144.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/dtan@2x.png
// module id = 1747
// module chunks = 0 1